import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 640; // Matches Tailwind's sm breakpoint
const SMALL_SCREEN_BREAKPOINT = 1024; // Matches Tailwind's lg breakpoint

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    // Initial check
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

export const useIsSmallScreen = (customBreakpoint?: number): boolean => {
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(false);
  const breakpoint = customBreakpoint || SMALL_SCREEN_BREAKPOINT;

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < breakpoint);
    };

    // Initial check
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isSmallScreen;
};

// Helper function to check if device is mobile